import { useTrans } from "../../../hooks";
// import {
//     Text,
//     VStack,
//     Flex,
//     Input,
//     Box,
//     HStack,
//     Button,
// } from "@chakra-ui/react";
import {
    AppPageHeader,
    // AppDatePicker,
    // AppIcon,
    // AppPageContent,
    // AppSelect,
    // AppSelectOption,
} from "../../../components";
// import { AppDateTimeSelectorContainer } from "../../../containers";
// import { useState } from "react";
// import { APPC } from "../../../config";

// const data = [
//     { date: "14-07-2025", weekDay: "Mon", isActive: true },
//     { date: "15-07-2025", weekDay: "Tue", isActive: true },
//     { date: "16-07-2025", weekDay: "Wed", isActive: true },
//     { date: "17-07-2025", weekDay: "Thu", isActive: true },
//     { date: "18-07-2025", weekDay: "Fri", isActive: true },
//     { date: "19-07-2025", weekDay: "Sat", isDisabled: true },
//     { date: "20-07-2025", weekDay: "Sun", isDisabled: true },
// ];

// const timesheetTypeOptionsData: AppSelectOption[] = [
//     {
//         value: "1",
//         label: "Work",
//     },
//     {
//         value: "2",
//         label: "Break",
//     },
// ];

export const DashboardPage = () => {
    const { t } = useTrans();
    // const [selectedStartTime, setSelectedStartTime] = useState<Date | null>(
    //     null
    // );
    // const [selectedEndTime, setSelectedEndTime] = useState<Date | null>(null);

    return (
        <>
            <AppPageHeader
                title={t("padm.DashboardPage:text.dashboard")}
            ></AppPageHeader>
            {/* <AppPageContent>
                <>
                    <VStack
                        p={6}
                        gap={6}
                        width="full"
                        alignItems={"flex-start"}
                    >
                        <AppDateTimeSelectorContainer data={data} />
                        <Flex
                            width="full"
                            alignItems={"center"}
                            gap={4}
                            overflowX={"auto"}
                            wrap={"nowrap"}
                        ></Flex>
                    </VStack>
                    <VStack
                        p={6}
                        gap={2}
                        height={"500px"}
                        alignItems={"flex-start"}
                        overflowX={"scroll"}
                    >
                        <HStack gap={2} w={"1000px"} alignItems={"flex-start"}>
                            <Box flex="0.80" textStyle={"mediumSm"}>
                                Timesheet Type
                            </Box>
                            <Box flex="0.40" textStyle={"mediumSm"}>
                                Start Time
                            </Box>
                            <Box flex="0.40" textStyle={"mediumSm"}>
                                End Time
                            </Box>
                            <Box flex="1.2" textStyle={"mediumSm"}>
                                Notes
                            </Box>
                            <Box flex="0.70" textStyle={"mediumSm"}>
                                Action
                            </Box>
                        </HStack>
                        <HStack gap={2} w={"1000px"} alignItems={"flex-start"}>
                            <Box flex="0.80">
                                <AppSelect<AppSelectOption>
                                    isClearable
                                    options={timesheetTypeOptionsData}
                                    placeholder={"Select timesheet type"}
                                />
                            </Box>
                            <Box flex="0.40">
                                <AppDatePicker
                                    selected={selectedStartTime}
                                    onChange={(date) => {
                                        setSelectedStartTime(date);
                                    }}
                                    placeholderText={t(
                                        "ent.InternshipSchedule:startTime.placeholder"
                                    )}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={60}
                                    timeCaption={t("cmn:label.time")}
                                    dateFormat={APPC.APP_DP_TIME_FORMAT}
                                    timeFormat={APPC.APP_DP_TIME_FORMAT}
                                    customInput={<Input />}
                                    isClearable={true}
                                />
                            </Box>
                            <Box flex="0.40">
                                <AppDatePicker
                                    selected={selectedEndTime}
                                    onChange={(date) => {
                                        setSelectedEndTime(date);
                                    }}
                                    placeholderText={t(
                                        "ent.InternshipSchedule:endTime.placeholder"
                                    )}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={60}
                                    timeCaption={t("cmn:label.time")}
                                    dateFormat={APPC.APP_DP_TIME_FORMAT}
                                    timeFormat={APPC.APP_DP_TIME_FORMAT}
                                    customInput={<Input />}
                                    isClearable={true}
                                />
                            </Box>
                            <Box flex="1.2">
                                <Input
                                    type="text"
                                    placeholder={"Enter notes"}
                                />
                            </Box>
                            <Box flex="0.7">
                                <HStack width={"full"}>
                                    <Button>Save</Button>
                                    <Button variant={"secondary"}>
                                        Cancel
                                    </Button>
                                </HStack>
                            </Box>
                        </HStack>
                        <HStack gap={2} w={"1000px"} alignItems={"flex-start"}>
                            <Box flex="0.80">
                                <AppSelect<AppSelectOption>
                                    isClearable
                                    options={timesheetTypeOptionsData}
                                    placeholder={"Select timesheet type"}
                                />
                            </Box>
                            <Box flex="0.40">
                                <AppDatePicker
                                    selected={selectedStartTime}
                                    onChange={(date) => {
                                        setSelectedStartTime(date);
                                    }}
                                    placeholderText={t(
                                        "ent.InternshipSchedule:startTime.placeholder"
                                    )}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={60}
                                    timeCaption={t("cmn:label.time")}
                                    dateFormat={APPC.APP_DP_TIME_FORMAT}
                                    timeFormat={APPC.APP_DP_TIME_FORMAT}
                                    customInput={<Input />}
                                    isClearable={true}
                                />
                            </Box>
                            <Box flex="0.40">
                                <AppDatePicker
                                    selected={selectedEndTime}
                                    onChange={(date) => {
                                        setSelectedEndTime(date);
                                    }}
                                    placeholderText={t(
                                        "ent.InternshipSchedule:endTime.placeholder"
                                    )}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={60}
                                    timeCaption={t("cmn:label.time")}
                                    dateFormat={APPC.APP_DP_TIME_FORMAT}
                                    timeFormat={APPC.APP_DP_TIME_FORMAT}
                                    customInput={<Input />}
                                    isClearable={true}
                                />
                            </Box>
                            <Box flex="1.2">
                                <Input
                                    type="text"
                                    placeholder={"Enter notes"}
                                />
                            </Box>
                            <Box flex="0.7">
                                <HStack width={"full"}>
                                    <Button>Save</Button>
                                    <Button variant={"secondary"}>
                                        Cancel
                                    </Button>
                                </HStack>
                            </Box>
                        </HStack>
                        <HStack gap={2} w={"1000px"} h={"41px"}>
                            <Box flex="0.80" textStyle={"mediumSm"}>
                                Work
                            </Box>
                            <Box flex="0.40" textStyle={"mediumSm"}>
                                10:00
                            </Box>
                            <Box flex="0.40" textStyle={"mediumSm"}>
                                17:00
                            </Box>
                            <Box
                                flex="1.2"
                                textStyle={"mediumSm"}
                                noOfLines={1}
                            >
                                It is a long established fact that a reader will
                                be distracted by the readable content of a page
                                when looking at its layout.
                            </Box>
                            <Box flex="0.7">
                                <HStack width={"full"} gap={4}>
                                    <Button variant={"unstyled"}>
                                        <AppIcon name="icl-pencil" w="1.5rem" />
                                    </Button>
                                    <Button variant={"unstyled"}>
                                        <AppIcon
                                            name="icl-trash"
                                            w="1.5rem"
                                            color={
                                                "var(--chakra-colors-destructive)"
                                            }
                                        />
                                    </Button>
                                </HStack>
                            </Box>
                        </HStack>
                        <HStack gap={2} w={"1000px"} h={"41px"}>
                            <Box flex="0.80" textStyle={"mediumSm"}>
                                Work
                            </Box>
                            <Box flex="0.40" textStyle={"mediumSm"}>
                                10:00
                            </Box>
                            <Box flex="0.40" textStyle={"mediumSm"}>
                                17:00
                            </Box>
                            <Box
                                flex="1.2"
                                textStyle={"mediumSm"}
                                noOfLines={1}
                            >
                                It is a long established fact that a reader will
                                be distracted by the readable content of a page
                                when looking at its layout.
                            </Box>
                            <Box flex="0.7">
                                <HStack width={"full"} gap={4}>
                                    <Button variant={"unstyled"}>
                                        <AppIcon name="icl-pencil" w="1.5rem" />
                                    </Button>
                                    <Button variant={"unstyled"}>
                                        <AppIcon
                                            name="icl-trash"
                                            w="1.5rem"
                                            color={
                                                "var(--chakra-colors-destructive)"
                                            }
                                        />
                                    </Button>
                                </HStack>
                            </Box>
                        </HStack>
                        <HStack gap={2} w={"1000px"} alignItems={"flex-start"}>
                            <Box flex="0.80">
                                <AppSelect<AppSelectOption>
                                    isClearable
                                    options={timesheetTypeOptionsData}
                                    placeholder={"Select timesheet type"}
                                />
                            </Box>
                            <Box flex="0.40">
                                <AppDatePicker
                                    selected={selectedStartTime}
                                    onChange={(date) => {
                                        setSelectedStartTime(date);
                                    }}
                                    placeholderText={t(
                                        "ent.InternshipSchedule:startTime.placeholder"
                                    )}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={60}
                                    timeCaption={t("cmn:label.time")}
                                    dateFormat={APPC.APP_DP_TIME_FORMAT}
                                    timeFormat={APPC.APP_DP_TIME_FORMAT}
                                    customInput={<Input />}
                                    isClearable={true}
                                />
                            </Box>
                            <Box flex="0.40">
                                <AppDatePicker
                                    selected={selectedEndTime}
                                    onChange={(date) => {
                                        setSelectedEndTime(date);
                                    }}
                                    placeholderText={t(
                                        "ent.InternshipSchedule:endTime.placeholder"
                                    )}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={60}
                                    timeCaption={t("cmn:label.time")}
                                    dateFormat={APPC.APP_DP_TIME_FORMAT}
                                    timeFormat={APPC.APP_DP_TIME_FORMAT}
                                    customInput={<Input />}
                                    isClearable={true}
                                />
                            </Box>
                            <Box flex="1.2">
                                <Input
                                    type="text"
                                    placeholder={"Enter notes"}
                                />
                            </Box>
                            <Box flex="0.7">
                                <HStack width={"full"} gap={4}>
                                    <Button variant={"unstyled"}>
                                        <AppIcon
                                            name="icl-check-double-alt"
                                            w="1.5rem"
                                            color={
                                                "var(--chakra-colors-success)"
                                            }
                                        />
                                    </Button>
                                    <Button variant={"unstyled"}>
                                        <AppIcon
                                            name="icl-x"
                                            w="1.5rem"
                                            color={
                                                "var(--chakra-colors-destructive)"
                                            }
                                        />
                                    </Button>
                                </HStack>
                            </Box>
                        </HStack>
                        <HStack gap={2} w={"1000px"} alignItems={"flex-start"}>
                            <Box flex="0.80">
                                <AppSelect<AppSelectOption>
                                    isClearable
                                    options={timesheetTypeOptionsData}
                                    placeholder={"Select timesheet type"}
                                />
                            </Box>
                            <Box flex="0.40">
                                <AppDatePicker
                                    selected={selectedStartTime}
                                    onChange={(date) => {
                                        setSelectedStartTime(date);
                                    }}
                                    placeholderText={t(
                                        "ent.InternshipSchedule:startTime.placeholder"
                                    )}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={60}
                                    timeCaption={t("cmn:label.time")}
                                    dateFormat={APPC.APP_DP_TIME_FORMAT}
                                    timeFormat={APPC.APP_DP_TIME_FORMAT}
                                    customInput={<Input />}
                                    isClearable={true}
                                />
                            </Box>
                            <Box flex="0.40">
                                <AppDatePicker
                                    selected={selectedEndTime}
                                    onChange={(date) => {
                                        setSelectedEndTime(date);
                                    }}
                                    placeholderText={t(
                                        "ent.InternshipSchedule:endTime.placeholder"
                                    )}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={60}
                                    timeCaption={t("cmn:label.time")}
                                    dateFormat={APPC.APP_DP_TIME_FORMAT}
                                    timeFormat={APPC.APP_DP_TIME_FORMAT}
                                    customInput={<Input />}
                                    isClearable={true}
                                />
                                <Text
                                    mt={1}
                                    textStyle={"regularXs"}
                                    color={"var(--chakra-colors-destructive)"}
                                >
                                    Required field
                                </Text>
                            </Box>
                            <Box flex="1.2">
                                <Input
                                    type="text"
                                    placeholder={"Enter notes"}
                                />
                            </Box>
                            <Box flex="0.7">
                                <HStack width={"full"} gap={4}>
                                    <Button variant={"unstyled"}>
                                        <AppIcon
                                            name="ics-check"
                                            w="1.5rem"
                                            color={
                                                "var(--chakra-colors-success)"
                                            }
                                        />
                                    </Button>
                                    <Button variant={"unstyled"}>
                                        <AppIcon
                                            name="ics-x"
                                            w="1.5rem"
                                            color={
                                                "var(--chakra-colors-destructive)"
                                            }
                                        />
                                    </Button>
                                </HStack>
                            </Box>
                        </HStack>
                        <HStack gap={2} w={"1000px"} alignItems={"flex-start"}>
                            <Box flex="0.80">
                                <AppSelect<AppSelectOption>
                                    isClearable
                                    options={timesheetTypeOptionsData}
                                    placeholder={"Select timesheet type"}
                                />
                            </Box>
                            <Box flex="0.40">
                                <AppDatePicker
                                    selected={selectedStartTime}
                                    onChange={(date) => {
                                        setSelectedStartTime(date);
                                    }}
                                    placeholderText={t(
                                        "ent.InternshipSchedule:startTime.placeholder"
                                    )}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={60}
                                    timeCaption={t("cmn:label.time")}
                                    dateFormat={APPC.APP_DP_TIME_FORMAT}
                                    timeFormat={APPC.APP_DP_TIME_FORMAT}
                                    customInput={<Input />}
                                    isClearable={true}
                                />
                            </Box>
                            <Box flex="0.40">
                                <AppDatePicker
                                    selected={selectedEndTime}
                                    onChange={(date) => {
                                        setSelectedEndTime(date);
                                    }}
                                    placeholderText={t(
                                        "ent.InternshipSchedule:endTime.placeholder"
                                    )}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={60}
                                    timeCaption={t("cmn:label.time")}
                                    dateFormat={APPC.APP_DP_TIME_FORMAT}
                                    timeFormat={APPC.APP_DP_TIME_FORMAT}
                                    customInput={<Input />}
                                    isClearable={true}
                                />
                            </Box>
                            <Box flex="1.2">
                                <Input
                                    type="text"
                                    placeholder={"Enter notes"}
                                />
                            </Box>
                            <Box flex="0.7">
                                <HStack width={"full"} gap={4}>
                                    <Button variant={"unstyled"}>
                                        <AppIcon
                                            name="ics-check"
                                            w="1.5rem"
                                            color={
                                                "var(--chakra-colors-success)"
                                            }
                                        />
                                    </Button>
                                    <Button variant={"unstyled"}>
                                        <AppIcon
                                            name="ics-x"
                                            w="1.5rem"
                                            color={
                                                "var(--chakra-colors-destructive)"
                                            }
                                        />
                                    </Button>
                                </HStack>
                            </Box>
                        </HStack>
                    </VStack>
                </>
            </AppPageContent> */}
        </>
    );
};
